(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');

    // click-directive to finish a task 
    module.directive('taskFinish', ['TaskService', 'TaskStateEnum',
        function (TaskService, TaskStateEnum) {
            var directive = {
                link: link,
                restrict: 'A',
                scope: {
                    task: '=' // task
                }
            };
            return directive;

            function link(scope, element) {

                // click listener
                element.on('click', function (e) {
                    finish();
                    e.preventDefault();
                    e.stopPropagation();
                });

                /* finish task */
                function finish() {
                    // show Finished-Modal
                    TaskService.showFinished(scope.task.id).then(function (result) {
                        // set new state
                        scope.task.taskState = TaskStateEnum.Finished.value;
                        scope.task.taskStateLabel = TaskStateEnum.Finished.name;
                        scope.task.updateVm();
                    });
                }


                // on destroy
                scope.$on("$destroy", function () {
                    element.off("click");
                });

            }
        }]);

})();